// extracted by mini-css-extract-plugin
export default {"fontWeightBold":"fontWeightBold__4QC9n","icon":"icon__2zNm9","sentence":"sentence__1or3F","uppercase":"uppercase__DRboK","italics":"italics__36Ptf"};